@if (item.visible !== false) {
  <a pRipple tabindex="0" [id]="getMenuItemId()" [attr.data-menu-id]="item.id"
    class="text-sm flex py-3 align-items-center cursor-pointer menu-item transition-duration-150 transition-colors justify-content-center"
    [ngClass]="[root ? 'justify-content-center flex-column border-round root-menu-item':'justify-content-between border-round border-round-left-xl', isCurrentRoute && root ? 'active-menu border-bottom-1 border-top-1' : '', this.active ? 'selected' : '', isCollapsed ? 'isCollapsed' : 'isExpanded']"
    (click)="itemClick($event)" (keyup)="itemClick($event)">
    @if (root) {
      <ng-container [ngTemplateOutlet]="rootMenuTemplate">
      </ng-container>
    }
    @if (!root) {
      <ng-container [ngTemplateOutlet]="submenuTemplate">
      </ng-container>
    }
  </a>
  <ul #submenu [id]="getSubmenuId()" [attr.data-submenu-id]="item.id"
    [hidden]="!(item.items?.length > 0 && this.showSubmenu)" class="z-1 list-none p-0 min-w-max ml-3 mt-1"
    [@children]="submenuAnimation" (@children.done)="onSubmenuAnimated($event)">
    @for (child of item.items; track child; let i = $index) {
      <li [id]="getChildMenuItemId(child.label || '')" [attr.data-list-item-id]="child.id">
        @if (!isCollapsed) {
          <app-menu-item [item]="child" [index]="i" [parentKey]="key" [parentItem]="this" class="submenu-item"
          [isCollapsed]="isCollapsed"></app-menu-item>
        }
      </li>
    }
  </ul>
}

<ng-template #rootMenuTemplate>
  <div class="flex w-full px-3">
    <div class="flex flex-1 align-items-center gap-3">
      @if (item.icon) {
        <i class="pi font-bold text-4xl" [ngClass]="item.icon"></i>
      }
      @if (!isCollapsed) {
        <span class="text-lg">{{item.label}}</span>
      }
    </div>
    @if (!isCollapsed) {
      <div class="flex align-items-center">
        @if (item.items) {
          <i class="pi pi-angle-down" [ngClass]="{'pi-angle-up': showSubmenu}"></i>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #submenuTemplate>
  <div class="flex w-full px-3">
    <div class="flex flex-1 align-items-center gap-3">
      @if (item.icon) {
        <i class="pi font-bold text-4xl" [ngClass]="item.icon"></i>
      }
      <span>{{item.label}}</span>
    </div>
    <div class="flex align-items-center">
      @if (item.items && !root) {
        <i class="pi pi-angle-down" [ngClass]="{'pi-angle-up': active}"></i>
      }
    </div>
  </div>
</ng-template>